import React from "react"

import {
    Box,
    Button,
    Chip, Tooltip,
    Typography,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import BlockIcon from "@mui/icons-material/Block"
import PersonIcon from "@mui/icons-material/Person"

import {
    t,
    Trans,
} from "@lingui/macro"
import { Link } from "react-router-dom"

import { ColoredProgressBar } from "components/commons"

import { getChipProps } from "components/commons/task-chip-props"


const defaultColumnDefinition: any = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getHistoryTableColumns = (): any => {
    return [

        {
            ...defaultColumnDefinition,
            field: "activity",
            headerName: t({
                id: "microjob.microjob-details.history-table.title",
                message: "Attività",
            }),
            flex: 4,
        },
        {
            ...defaultColumnDefinition,
            field: "date",
            headerName: t({
                id: "microjob.microjob-details.history-table.date",
                message: "Data"
            }),
            flex: 1,
        },
        {
            ...defaultColumnDefinition,
            field: "button",
            flex: 1,
            sortable: false,
            renderCell: (params: { row: any }) => (
                <Link key={`task-${params.row.id}`} to={`/microjob`}>
                    <Button
                        variant="contained"
                        disableElevation
                        sx={{
                            textTransform: 'none',
                            backgroundColor: 'secondary.main',
                            color: 'white',
                            paddingX: 5,
                            height: 28,
                        }}>
                        <Typography>
                            <Trans id="brand-table.view-details">
                                Vedi dettagli
                            </Trans>
                        </Typography>
                    </Button>
                </Link>

            ),
        },
    ]
}

export default getHistoryTableColumns
